import * as React from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

const Confirm = (props) => {
    return (<div>
        <Dialog
          className="wm-dialog wm-confirm-dialog"
          title={(
            <span className="wm-confirm-dialog__title">
              <span className="wm-confirm-dialog__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" focusable="false">
                  <path d="M8 8v9m4-9v9m4-9v9M5 5h14M9 5V3h6v2m-9 0 1 16h10l1-16" />
                </svg>
              </span>
              <span>{props.Title}</span>
            </span>
          )}
          onClose={props.NoClicked}
        >
          <div className="wm-confirm-dialog__content">
            <p>{props.Message}</p>
            <span>This action cannot be undone.</span>
          </div>
          <DialogActionsBar layout="end">
            <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base wm-dialog__cancel" onClick={props.NoClicked}>Cancel</button>
            <button className="k-button k-button-md k-rounded-md k-button-solid wm-dialog__danger" onClick={props.YesClicked}>
              <span className="k-icon k-i-delete" aria-hidden="true" />
              Delete
            </button>
          </DialogActionsBar>
        </Dialog>
      </div>);
}
export default Confirm
